import Repository from './Repository';

const resource = '/competencias-tecnicas';

export default {
  agrupar(nomeCompetenciaAgrupadora, competencias, mapeamento, etapa) {
    let parametros = competencias.map((c) => `competencia=${c.id}`);
    parametros = parametros.join('&');

    const nomeCompetenciaAgrupadoraEncoded = encodeURIComponent(nomeCompetenciaAgrupadora);
    const mapeamentoParam = `mapeamento=${mapeamento.id}`;
    const etapaParam = `etapa=${etapa.toUpperCase()}`;

    return Repository.post(
      `${resource}/tecnica/agrupamento/?nomeCompetenciaAgrupadora=${nomeCompetenciaAgrupadoraEncoded}&`
        + `${parametros}&${mapeamentoParam}&${etapaParam}`,
    );
  },

  create(payload) {
    return Repository.post(`${resource}/`, payload);
  },

  update(id, unidadesSelecionadas, payload) {
    const unidadesParam = unidadesSelecionadas.reduce((acumulador, u) => acumulador.concat(`&unidades=${u.id}`), '');
    return Repository.put(`${resource}/${id}?${unidadesParam}`, payload);
  },

  delete(id, unidadesSelecionadas) {
    const unidadesParam = unidadesSelecionadas.reduce((acumulador, u) => acumulador.concat(`&unidades=${u.id}`), '');
    return Repository.delete(`${resource}/${id}?${unidadesParam}`);
  },
};
